import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UserModel extends BaseModel {

    constructor() {
        super({ 
                name: "user",
                tableName: 'users', 
                label: "Danh Sách Khách Hàng", 
                display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            avatar: {
                name: 'avatar', 
                type: "Image",
                label: 'Avatar',
                // inputOptions: { mode: 'multiple' },  
                // display: false,
                accessable: "image/*"
            },
            code : { 
                name: 'code', 
                type: "String", 
                label: 'Mã KH', 
                sortable: false,
                width : 8, 
                filter: { type: 'input', match: 'contains'},
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên khách hàng',
                width :15, 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            phone : {
                name: 'phone', 
                type: "String", 
                label: 'Số điện thoại', 
                sortable: false,
                width : 10,
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            }
        },)
    }

}